// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Tooltip = require("../../../reason/common/Tooltip.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var VisuallyHidden = require("@reach/visually-hidden").default;

function MyClientsWidgetComponents$HelperIcon(props) {
  var label = props.label;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(VisuallyHidden, {
                      children: label
                    }),
                JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(Tooltip.make, {
                            label: label,
                            children: JsxRuntime.jsx("span", {
                                  children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                        icon: props.icon,
                                        className: "align-baseline inline-block text-gray-400",
                                        size: 17
                                      })
                                })
                          }),
                      "aria-hidden": true
                    })
              ]
            });
}

var HelperIcon = {
  make: MyClientsWidgetComponents$HelperIcon
};

function MyClientsWidgetComponents$HiddenAddressIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
              label: "Hidden Address",
              icon: "Lock"
            });
}

var HiddenAddressIcon = {
  make: MyClientsWidgetComponents$HiddenAddressIcon
};

function MyClientsWidgetComponents$AutoNotifyIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
              label: "Auto-notify is on",
              icon: "Bell"
            });
}

var AutoNotifyIcon = {
  make: MyClientsWidgetComponents$AutoNotifyIcon
};

exports.HelperIcon = HelperIcon;
exports.HiddenAddressIcon = HiddenAddressIcon;
exports.AutoNotifyIcon = AutoNotifyIcon;
/* Tooltip Not a pure module */
